

import React from 'react';
import _isEmpty from 'lodash.isempty';
import { FormModal } from '../../../../../ui-kit';
import OutputsAndAddonsSection from '../../OutputsAndAddons';
import AddonsFinalCost from './AddonsFinalCost';
import { getCurrentVersion, getFlagStatus } from '../../../../../common/utils';
import { getTotalCost } from '../utils';

import '../styles/_addon-management-modal.scss';
import BadgeStatus from './BadgeStatus';





































export default class AddonManagementModal extends React.Component


{
  constructor(props) {
    super(props);

    const {
      video: { outputs }
    } = this.props;

    this.state = {
      totalCost: 0,
      outputs,
      submittedVoiceOverArtists: [],
      paymentStatus: 'OPEN',
      clientType: '',
      enabledPaymentGateway: false
    };
  }

  componentDidMount() {
    const { hideVoiceOvers } = this.props;
    this.calculateTotalCost();
    this.loadPaymentStatus();
    if (!hideVoiceOvers) {
      this.getSubmittedVoiceOverArtists();
    }
  }

  async getSubmittedVoiceOverArtists() {
    const { video, getFilteredVoiceOverArtists } = this.props;
    const { outputs: VideoOutputs } = video;
    const masterOutput = VideoOutputs.find(({ isMaster }) => isMaster);
    const { versions, latestVersion } = masterOutput;
    const { appliedAddons } = versions.find(({ versionNumber }) => versionNumber === latestVersion) ||
    {};

    const voiceOverArtistIds = appliedAddons.VOICE_OVER_ARTISTS &&
    appliedAddons.VOICE_OVER_ARTISTS.length &&
    appliedAddons.VOICE_OVER_ARTISTS.map(({ artistId }) => artistId);

    if (_isEmpty(voiceOverArtistIds)) {
      return;
    }

    const payload = {
      where: { voiceOverArtistIds }
    };

    const { data, error } = await getFilteredVoiceOverArtists(payload);
    if (error || !data) {
      return;
    }

    const {
      getFilteredVoiceOverArtists: { VoiceOverArtist: voiceOverArtist }
    } = data;

    const filteredVoiceOverArtists = voiceOverArtist.map(
      ({ voiceOverArtistId: artistId, artistName: name }) => ({
        artistId,
        name
      })
    );

    this.setState((prevState) => ({
      submittedVoiceOverArtists: [
      ...(prevState.submittedVoiceOverArtists || []),
      ...filteredVoiceOverArtists]

    }));
  }

  calculateTotalCost = () => {
    const { outputId } = this.props;
    const { outputs } = this.state;

    const currentOutput = outputs.find((output) => output.outputId === outputId);

    if (!currentOutput) {
      return;
    }

    const { versions, latestVersion, isMaster } = currentOutput;
    const { appliedAddons = {} } = getCurrentVersion({
      versions,
      latestVersion
    });
    const countedItems = isMaster ?
    { addons: appliedAddons, iterations: [...outputs].splice(1) } :
    { addons: appliedAddons };

    this.setState({ totalCost: getTotalCost(countedItems) });
  };

  onAddonsSave = async (addonsToSave) =>


  {
    const { onSaveAddons, outputId } = this.props;
    const { outputs } = this.state;
    const { error, data } = await onSaveAddons(addonsToSave);

    if (!data || error) {
      return;
    }

    const {
      updateAppliedAddons: { appliedAddons }
    } = data;
    const outputIndex = outputs.findIndex(
      (output) => output.outputId === outputId
    );
    const outputToUpdate = outputs[outputIndex];
    const currentVersion = getCurrentVersion(outputToUpdate);
    const versionIndex = outputToUpdate.versions.findIndex(
      (version) => version.versionId === currentVersion.versionId
    );
    const newVersion = { ...currentVersion, appliedAddons };
    const updatedVersions = [...outputToUpdate.versions];

    updatedVersions.splice(versionIndex, 1, newVersion);

    const newOutput = { ...outputToUpdate, versions: updatedVersions };
    const newOutputs = [...outputs];

    newOutputs.splice(outputIndex, 1, newOutput);

    this.setState({ outputs: newOutputs }, this.calculateTotalCost);
  };

  onOutputsSave = async (outputsToSave) => {
    const { onSaveOutputs } = this.props;

    const { error, outputs } = await onSaveOutputs(outputsToSave);

    if (error) {
      return Promise.resolve({ error });
    }

    this.setState({ outputs }, this.calculateTotalCost);

    return Promise.resolve({ outputs });
  };

  formatSubtotal = () => {
    const { totalCost } = this.state;
    const { getCurrencySymbol } = this.props;

    return `${getCurrencySymbol()}${totalCost}`;
  };

  loadPaymentStatus = async () => {
    const {
      getVideoPaymentStatus,
      video: { videoId },
      getOrganisation
    } = this.props;

    const { data: organisationData, error: organisationError } = await getOrganisation();

    if (organisationError || !organisationData?.getOrganisation) {
      return;
    }

    const { alias, clientType } = organisationData.getOrganisation;

    this.setState({ clientType });

    const enabledPaymentGateway = await getFlagStatus({
      orgAlias: alias,
      flagName: 'enabled-payment-gateway'
    });

    this.setState({ enabledPaymentGateway });

    if (!enabledPaymentGateway) return;

    const {
      data: paymentStatusData,
      error: paymentStatusError
    } = await getVideoPaymentStatus({ videoId });

    if (paymentStatusError || !paymentStatusData) return;

    const status = paymentStatusData?.getVideoPaymentStatus?.status;

    this.setState({ paymentStatus: status });
  };

  render() {
    const {
      visible,
      onClose,
      getCurrencySymbol,
      video,
      outputId,
      getAddonsCost,
      additionalOutputCost,
      canUpdateVideo,
      hasUpdatePermission,
      editingMode,
      hideRushEdit,
      hideBurnInCaptions,
      hideSrtCaption,
      hideVoiceOver,
      hideVoiceOvers,
      hideSocialIterations,
      hideSupersizeMyEdit,
      voiceOverPriceVersion,
      openHubSpotConversationsWidget
    } = this.props;

    const {
      submittedVoiceOverArtists,
      paymentStatus,
      clientType,
      enabledPaymentGateway
    } = this.state;

    const finalCostComponent =
    <AddonsFinalCost
      className="outputs-and-addons__addons-final-cost"
      subtotal={this.formatSubtotal()}
      paymentStatus={paymentStatus} />;



    return (
      <FormModal
        title="Manage Add-ons"
        subtitle={!enabledPaymentGateway && 'Select from the options below'}
        description={enabledPaymentGateway && `Add-ons cannot be edited if a customer has paid for it. Costs can only
          be modified after a full refund is provided. Please coordinate this
          with the customer if required.`}
        visible={visible}
        onClose={onClose}
        closeText="Close"
        className="addon-management-modal"
        footerChildren={finalCostComponent}
        headerSuffix={clientType === 'B2B' && <BadgeStatus type="PRIMARY" labelText="Subscribed" />}>

        <div className="addon-management-modal__container">
          <OutputsAndAddonsSection
            getAddonsCost={getAddonsCost}
            onSaveAddons={this.onAddonsSave}
            onSaveOutputs={this.onOutputsSave}
            canUpdateVideo={paymentStatus !== 'SUCCEEDED' && canUpdateVideo}
            hasUpdatePermission={hasUpdatePermission}
            shouldShowSupersizeMyEdit
            additionalOutputCost={additionalOutputCost}
            video={video}
            outputId={outputId}
            editingMode={editingMode}
            getCurrencySymbol={getCurrencySymbol}
            hideRushEdit={hideRushEdit}
            hideBurnInCaptions={hideBurnInCaptions}
            hideSrtCaption={hideSrtCaption}
            hideVoiceOver={hideVoiceOver}
            hideVoiceOvers={hideVoiceOvers}
            hideSocialIterations={hideSocialIterations}
            hideSupersizeMyEdit={hideSupersizeMyEdit}
            submittedVoiceOverArtists={submittedVoiceOverArtists}
            priceVersion={voiceOverPriceVersion}
            openHubSpotConversationsWidget={openHubSpotConversationsWidget} />

        </div>
      </FormModal>);

  }
}